import React from "react"
import styles from "./forms.module.css"
import clsx from "clsx"

/**
 * @typedef {React.InputHTMLAttributes<HTMLInputElement>} InputProps
 */

/**
 * @type {React.ForwardRefExoticComponent<InputProps & React.RefAttributes<HTMLInputElement>>}
 */
export const FormInput = React.forwardRef((props, ref) => {
  const { type = "text", className, onChange, ...rest } = props
  return (
    <input
      ref={ref}
      type={type}
      className={clsx(styles.input, className)}
      onChange={onChange}
      {...rest}
    />
  )
})

/**
 * @param {React.ComponentProps<"select">} props 
 */
export function FormSelect({ className, ...props }) {
  return (
    <select
      className={clsx(styles.input, className)}
      {...props}
    />
  )
}

/**
 * @param {React.ComponentProps<"label">} props 
 */
export function FormLabel({ className, ...props }) {
  return (
    <label
      className={clsx(styles.label, className)}
      {...props}
    />
  )
}
